import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ThemeProvider from 'components/theme/ThemeProvider';
import NotFound from 'views/NotFound';
import View from 'layouts/View';
import WrapIf from 'components/WrapIf';
import Button from 'components/mui/Button';

const AppErrorFallback = memo(function AppErrorFallback(props) {
  const { error, theme, resetError, Layout = View } = props;

  return (
    <WrapIf if={!!theme} Wrapper={ThemeProvider} theme={theme}>
      <NotFound
        title={error?.status || 'Whoops...'}
        text={error?.message || 'Something went wrong'}
        Layout={Layout}
        nodeAfter={
          resetError ? (
            <>
              <Button
                onClick={resetError}
                style={{
                  display: 'block',
                  margin: '20px auto',
                }}
              >
                Retry
              </Button>
            </>
          ) : undefined
        }
      />
    </WrapIf>
  );
});

AppErrorFallback.propTypes = {
  theme: PropTypes.object,
  error: PropTypes.object,
  resetError: PropTypes.func,
  Layout: PropTypes.node,
};

export default AppErrorFallback;
